import { Avatar, AvatarGroup, Stack, Tooltip, Typography } from '@mui/material'

import React from 'react'
import { useTranslation } from 'react-i18next'

export type MenuProviderVendor = {
  id: string
  companyName: string
  logo?: string | null
}

type Props = {
  vendorData: MenuProviderVendor[]
}

const MAX_AVATARS = 5
const AVATAR_SHADOW = '0 2px 4px rgba(0, 0, 0, 0.18)'

const MenuProviders: React.FC<Props> = ({ vendorData }) => {
  const { t } = useTranslation()

  if (vendorData.length === 0) {
    return null
  }

  // AvatarGroup renders surplus when we provide max but we need tooltip so we render this ourselves
  const showSurplus = vendorData.length > MAX_AVATARS
  const visibleVendors = showSurplus ? vendorData.slice(0, MAX_AVATARS - 1) : vendorData
  const hiddenVendors = vendorData.slice(visibleVendors.length)
  const surplusCount = hiddenVendors.length

  return (
    <Stack direction="row" alignItems="center" spacing={1} sx={{ whiteSpace: 'nowrap' }}>
      <Typography variant="subtitle2" color="text.secondary">
        {t('cc:menusBy')}
      </Typography>
      <AvatarGroup
        max={MAX_AVATARS}
        sx={{
          '& .MuiAvatar-root': {
            width: 48,
            height: 48,
            fontSize: 18,
            boxShadow: AVATAR_SHADOW,
          },
        }}>
        {visibleVendors.map((vendor) => (
          <Tooltip key={vendor.id} title={vendor.companyName}>
            <Avatar alt={vendor.companyName} src={vendor.logo ?? undefined}>
              {vendor.companyName.charAt(0)}
            </Avatar>
          </Tooltip>
        ))}
        {showSurplus ? (
          <Tooltip
            title={
              <Stack spacing={0.25}>
                {hiddenVendors.map((vendor) => (
                  <Typography key={vendor.id} variant="body2" color="inherit">
                    {vendor.companyName}
                  </Typography>
                ))}
              </Stack>
            }>
            <Avatar>+{surplusCount}</Avatar>
          </Tooltip>
        ) : null}
      </AvatarGroup>
    </Stack>
  )
}

export default MenuProviders
